import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'localeSort'
})
export class LocaleSortPipe implements PipeTransform {

  transform(items: any, field: string): Array<any> {
    // @ts-ignore
    const lang = $localize.locale.split('-')[0]
    return items.sort((a: any, b: any) => (a[field + '_' + lang] ? a[field + '_' + lang] : a[field]).localeCompare(b[field + '_' + lang] ? b[field + '_' + lang] : b[field]), lang)
  }
}
